module.exports = __webpack_public_path__ + "static/media/pm_news_demo.b71e4639.svg";